import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    AppBar,
    Box,
    Button,
    CardContent,
    Checkbox,
    colors,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    Switch,
    Tab,
    Tabs,
    TextField,
    Typography,
    Paper
} from '@material-ui/core';

import api from 'services/api';
import { ANAO, ASIM, ATIPO_VENDEDOR_ESPECIFICO } from 'consts';
import {
    getApiErrorMessage,
    getFormMode,
    getRecordFromResponse,
    getResponseData,
    validateSchemaFields
} from 'lib/formUtils';
import { safeSetState } from 'lib/reactUtils';
import { formatDateForInput } from 'lib/functions';
import { getConfigField } from 'lib/configUtils';

import { AlertInformation } from 'components';
import { ComboPadrao, FormActions, FormStatusSwitch } from 'views/Components';
import ComissaoVendedorServico from './ComissaoVendedorServico';

function TabContainer(props) {
    return (
        <Typography
            component="div"
        // style={{ padding: 8 * 3 }}
        >
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

// Definição dos estilos
const styles = theme => ({
    // textField: {
    //     marginTop: theme.spacing(0), // Margem superior
    //     marginBottom: "0.5rem", // Margem inferior
    //     marginRight: "0.5rem", // Margem direita
    // },
    // addButton: {
    //     height: '42px',
    //     display: 'flex',
    //     alignItems: 'center',
    //     float: 'right', // alinhamento a direita
    // },
    // textarea: {
    //     width: '100%',
    //     height: '100px',
    //     padding: theme.spacing(1),
    //     boxSizing: 'border-box',
    // },
    // dialogContent: {
    //     padding: theme.spacing(2),
    // },
});

class VendedorForm extends Component {
    _isMounted = false;
    safeSetState = safeSetState;

    state = {
        vendedor: {
            nomevendedor: '',
            inativo: ANAO,
            vendedorexterno: ANAO,
            email: ''
        },
        funcionarios: [],
        clientes: [],
        fornecedores: [],
        usuarios: [],
        comissaoservicos: null,
        empresas: [],
        empresasSelecionadas: [],
        activetab: 0,
        isLoading: true,
        isNewRecord: false,
        isView: false,
        openAlert: false,
        messageAlert: '',
        openComissaoServico: false,
        errors: {},
        schema: {
            nomevendedor: {
                presence: {
                    allowEmpty: false,
                    message: 'Nome do vendedor obrigatório'
                },
                length: { maximum: 100 },
                type: 'string'
            }
        }
    };

    async componentDidMount() {
        this._isMounted = true;

        const { id, isNewRecord, isView } = getFormMode(this.props.match, this.props.location);

        const possibvincvendedorcliente = getConfigField('possibvincvendedorcliente') === ASIM;
        const vincvendexternoafornec = getConfigField('vincvendexternoafornec') === ASIM;

        try {
            const [funcionarios, clientes, fornecedores, usuarios, empresas] =
                await Promise.all([
                    this.loadFuncionarios(),
                    possibvincvendedorcliente ? this.loadClientes() : Promise.resolve([]),
                    vincvendexternoafornec ? this.loadFornecedores() : Promise.resolve([]),
                    vincvendexternoafornec ? this.loadUsuarios() : Promise.resolve([]),
                    this.loadEmpresas()
                ]);

            if (isNewRecord) {
                const codEmpresaLogada = Number(sessionStorage.getItem('codEmpresa'));

                const empresasSelecionadas = empresas.length > 1 ? [] : (Number.isInteger(codEmpresaLogada) && codEmpresaLogada > 0 ? [codEmpresaLogada] : []);

                this.safeSetState({
                    isNewRecord: true,
                    isView: false,
                    isLoading: false,
                    vendedor: this.getVendedorDefault(),
                    funcionarios,
                    clientes,
                    fornecedores,
                    usuarios,
                    empresas,
                    empresasSelecionadas,
                    activetab: 0
                });

                return;
            }

            if (!isNaN(Number(id))) {
                const response = await api.get(`/vendedor/${id}`);
                const registro = getRecordFromResponse(response);

                if (!registro) {
                    this.handleOpenAlert('Vendedor não encontrado!');
                    this.props.history.push(this.getBasePath());
                    return;
                }

                const vendedor = {
                    ...this.getVendedorDefault(),
                    ...registro,
                    datanasc: registro.datanasc ? formatDateForInput(registro.datanasc) : ''
                };

                const empresasSelecionadas = await this.loadEmpresasVendedor(
                    vendedor.codvendedor
                );

                const [
                    funcionariosAtualizados,
                    clientesAtualizados,
                    fornecedoresAtualizados,
                    usuariosAtualizados
                ] = await Promise.all([
                    this.loadFuncionarios(vendedor.codfuncionario),
                    possibvincvendedorcliente ? this.loadClientes(vendedor.codcliente) : Promise.resolve([]),
                    vincvendexternoafornec ? this.loadFornecedores(vendedor.codfornecedor) : Promise.resolve([]),
                    vincvendexternoafornec ? this.loadUsuarios(vendedor.codusuario) : Promise.resolve([])
                ]);

                this.safeSetState({
                    vendedor,
                    funcionarios: funcionariosAtualizados,
                    clientes: clientesAtualizados,
                    fornecedores: fornecedoresAtualizados,
                    usuarios: usuariosAtualizados,
                    empresas,
                    empresasSelecionadas,
                    isNewRecord: false,
                    isView,
                    isLoading: false,
                    activetab: 0
                });
            }
        } catch (error) {
            console.error(
                'Erro ao carregar o vendedor:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(error, 'Erro ao carregar o vendedor!')
            );

            this.safeSetState({ isLoading: false });
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getVendedorDefault = () => ({
        nomevendedor: '',
        inativo: ANAO,
        vendedorexterno: ANAO,
        email: '',
        datanasc: '',
        codfuncionario: '',
        codcliente: 0,
        codfornecedor: 0,
        codusuario: 0,
        calccomissdedcusto: ANAO
    });

    loadFuncionarios = async (codfuncionario) => {
        const url = codfuncionario ? `/funcionario/listforchange/${codfuncionario}` : '/funcionario/active/true';

        const response = await api.get(url);

        return getResponseData(response);
    };

    loadClientes = async (codcliente) => {
        const url = codcliente ? `/cliente/listforchange/${codcliente}` : '/cliente/active/true';

        const response = await api.get(url);

        return getResponseData(response);
    };

    loadFornecedores = async (codfornecedor) => {
        const url = codfornecedor ? `/fornecedor/listforchange/${codfornecedor}` : '/fornecedor/active/true';

        const response = await api.get(url);

        return getResponseData(response);
    };

    loadUsuarios = async (codusuario) => {
        const url = codusuario ? `/usuario/listforchange/${codusuario}` : '/usuario/active/true';

        const response = await api.get(url);

        return getResponseData(response);
    };

    loadEmpresas = async () => {
        const response = await api.get('/empresa');
        return getResponseData(response);
    };

    loadEmpresasVendedor = async (codVendedor) => {
        const response = await api.get(
            `/vendedor/empresas/${codVendedor}`
        );

        return getResponseData(response).map(
            item => Number(item.codempresa)
        );
    };

    onChange = (event) => {
        const { name, type, value, checked } = event.target;

        let adjustedValue = value;
        let camposZerados = {};

        switch (type) {
            case 'checkbox':
                if (name === 'inativo') {
                    adjustedValue = checked ? ANAO : ASIM;
                } else {
                    adjustedValue = checked ? ASIM : ANAO;
                }

                if (name === 'vendedorexterno' && !checked) {
                    camposZerados = {
                        codcliente: 0,
                        codfornecedor: 0,
                        codusuario: 0
                    };
                }
                break;

            case 'select-one':
            case 'radio':
                adjustedValue = Number(value);
                break;

            default:
                if (name === 'foneresidencial' || name === 'fonecelular') {
                    adjustedValue = value.replace(/[a-zA-Z]/g, '');
                } else if (name !== 'email') {
                    adjustedValue = value.toUpperCase();
                }
                break;
        }

        this.setState(prevState => ({
            vendedor: {
                ...prevState.vendedor,
                ...camposZerados,
                [name]: adjustedValue
            },
            errors: {
                ...prevState.errors,
                [name]: undefined
            }
        }));
    };

    /* abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.safeSetState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.safeSetState({ openAlert: false });
    };

    handleChangeTab = (event, value) => {
        this.setState({ activetab: value });
    };

    updateComissaoServicos = (comissaoServicos) => {
        this.setState({ comissaoservicos: comissaoServicos });
    };

    getBasePath = () => {
        const path = this.props.match?.path || '/front/vendedores/:id';

        return path.replace('/:id', '');
    };

    onClickCancel = () => {
        this.props.history.push(this.getBasePath());
    };

    validationRequiredFields = () => {
        const { vendedor, schema } = this.state;

        return validateSchemaFields(
            vendedor,
            schema,
            ['nomevendedor']
        );
    };

    getPayloadVendedor = () => {
        const { vendedor, comissaoservicos, empresasSelecionadas } = this.state;

        const payload = { ...vendedor };        

        if (comissaoservicos !== null) {
            payload.comissaoservicos = comissaoservicos
                .filter(item =>
                    Number(item.perccomissao) > 0 ||
                    Number(item.valorporpax) > 0 ||
                    Number(item.valorporpaxchd) > 0 ||
                    Number(item.valorporpaxinf) > 0 ||
                    Number(item.valorporpaxsen) > 0 ||
                    Number(item.perccomissaoadt) > 0 ||
                    Number(item.perccomissaochd) > 0 ||
                    Number(item.perccomissaoinf) > 0 ||
                    Number(item.perccomissaosen) > 0
                )
                .map(item => ({
                    codservico: item.codservico,
                    perccomissao: item.perccomissao,
                    valorporpax: item.valorporpax,
                    valorporpaxchd: item.valorporpaxchd,
                    valorporpaxinf: item.valorporpaxinf,
                    valorporpaxsen: item.valorporpaxsen,
                    calculacomissobreliquido: item.calculacomissobreliquido,
                    perccomissaoadt: item.perccomissaoadt,
                    perccomissaochd: item.perccomissaochd,
                    perccomissaoinf: item.perccomissaoinf,
                    perccomissaosen: item.perccomissaosen
                }));
        }
        
        payload.empresas = empresasSelecionadas;

        return payload;
    };

    onClickSave = async () => {
        const { vendedor, isNewRecord } = this.state;

        const errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');
            return;
        }

        const email = vendedor.email?.trim();

        if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            this.handleOpenAlert('Formato de e-mail inválido!');
            return;
        }

        if (
            this.state.empresas.length > 1 &&
            this.state.empresasSelecionadas.length === 0
        ) {
            this.handleOpenAlert('Selecione pelo menos uma empresa!');
            return;
        }

        try {
            const payload = this.getPayloadVendedor();

            if (isNewRecord) {
                await api.post('/vendedor', payload);
            } else {
                await api.put(`/vendedor/${vendedor.codvendedor}`, payload);
            }

            this.props.history.push(this.getBasePath());
        } catch (error) {
            console.error(
                'Erro ao salvar o vendedor:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(error, 'Erro ao salvar o vendedor!')
            );
        }
    };

    /* abre janela de comissão serviço */
    handleOpenComissaoServico = () => {
        this.setState({ openComissaoServico: true });
    };

    /* fecha janela de comissão serviço */
    handleCloseComissaoServico = () => {
        this.safeSetState({ openComissaoServico: false });
    };

    handleEmpresaChange = (codigoEmpresa) => {
        this.setState(prevState => {
            const codigo = Number(codigoEmpresa);
            const selecionadas = prevState.empresasSelecionadas || [];

            const jaSelecionada = selecionadas.some(
                item => Number(item) === codigo
            );

            return {
                empresasSelecionadas: jaSelecionada
                    ? selecionadas.filter(item => Number(item) !== codigo)
                    : [...selecionadas, codigo]
            };
        });
    };

    render() {
        const {
            vendedor,
            activetab,
            funcionarios,
            clientes,
            fornecedores,
            usuarios,
            empresas,
            isLoading,
            isView,
            errors,
            openAlert,
            messageAlert,
            openComissaoServico,
            comissaoservicos
        } = this.state;

        const { classes } = this.props;

        if (isLoading) {
            return (
                <CardContent>
                    <Typography variant="body1">
                        Carregando vendedor...
                    </Typography>
                </CardContent>
            );
        }

        // campos configurações
        const calculacomissdedcusto = (getConfigField('calculacomissdedcusto') == ASIM);
        const tipovenddedcustocomiss = getConfigField('tipovenddedcustocomiss');
        const possibvincvendedorcliente = (getConfigField('possibvincvendedorcliente') == ASIM);
        const vincvendexternoafornec = (getConfigField('vincvendexternoafornec') == ASIM);

        return (
            <div>
                <AppBar
                    color="default"
                    position="static"
                >
                    <Tabs
                        indicatorColor="primary"
                        onChange={this.handleChangeTab}
                        scrollButtons="auto"
                        scrollable
                        variant="scrollable"
                        textColor="primary"
                        value={activetab}
                    >
                        <Tab label="Dados" />
                        {empresas.length > 1 && (
                            <Tab label="Empresa" />
                        )}
                    </Tabs>
                </AppBar>

                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Typography component="h1" variant="h3">
                            Vendedor {vendedor.codvendedor} - {vendedor.nomevendedor}
                        </Typography>

                        <FormStatusSwitch
                            checked={vendedor.inativo !== ASIM}
                            name="inativo"
                            onChange={this.onChange}
                            disabled={isView}
                        />
                    </Box>

                    {/* Aba Dados */}
                    {activetab === 0 &&
                        <TabContainer>
                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12, marginTop: 10 }}
                            >
                                <TextField
                                    label="Nome"
                                    name="nomevendedor"
                                    value={vendedor.nomevendedor || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    helperText={errors.nomevendedor || ' '}
                                    error={!!errors.nomevendedor}
                                    disabled={isView}
                                    inputProps={{ maxLength: 100 }}
                                    fullWidth
                                />
                            </Box>

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12, marginTop: 12 }}
                            >
                                <FormControl
                                    fullWidth
                                    variant="outlined"
                                    disabled={isView || (vendedor.vendedorexterno == ASIM)}
                                >
                                    <ComboPadrao
                                        name="codfuncionario"
                                        label="Funcionário"
                                        value={vendedor.codfuncionario}
                                        onChange={this.onChange}
                                        fieldId="codfuncionario"
                                        listItems={funcionarios}
                                        fieldDescription="nome"
                                        disabled={isView || (vendedor.vendedorexterno == ASIM)}
                                    />
                                </FormControl>
                            </Box>

                            <Box
                                display="flex"
                                alignItems="center"
                                flexWrap="wrap"
                                style={{ gap: 12, marginTop: 12 }}
                            >
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    label="Data de nascimento"
                                    name="datanasc"
                                    onChange={this.onChange}
                                    type="date"
                                    value={vendedor.datanasc || ''}
                                    variant="outlined"
                                    disabled={isView}
                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={vendedor.vendedorexterno === ASIM}
                                            name="vendedorexterno"
                                            onChange={this.onChange}
                                            color="primary"
                                            disabled={isView}
                                        />
                                    }
                                    label="Vendedor externo"
                                />

                                {calculacomissdedcusto &&
                                    tipovenddedcustocomiss === ATIPO_VENDEDOR_ESPECIFICO && (
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={vendedor.calccomissdedcusto === ASIM}
                                                    name="calccomissdedcusto"
                                                    onChange={this.onChange}
                                                    color="primary"
                                                    disabled={isView}
                                                />
                                            }
                                            label="Calcula comissão deduzindo custo"
                                        />
                                    )}

                                <Button
                                    color="primary"
                                    style={{
                                        backgroundColor: colors.grey[300],
                                        color: 'black',
                                        height: 40,
                                    }}
                                    variant="contained"
                                    onClick={this.handleOpenComissaoServico}
                                    disabled={isView}
                                >
                                    % Comissão serviço
                                </Button>
                            </Box>

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12, marginTop: 12 }}
                            >
                                <TextField
                                    label="Fone residencial"
                                    name="foneresidencial"
                                    value={vendedor.foneresidencial || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 20 }}
                                    style={{ flex: 1, minWidth: 180 }}
                                />

                                <TextField
                                    label="Fone celular"
                                    name="fonecelular"
                                    value={vendedor.fonecelular || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 20 }}
                                    style={{ flex: 1, minWidth: 180 }}
                                />

                                <TextField
                                    label="E-mail"
                                    name="email"
                                    value={vendedor.email || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 100 }}
                                    style={{ flex: 2, minWidth: 260 }}
                                />
                            </Box>

                            {possibvincvendedorcliente &&
                                vendedor.vendedorexterno == ASIM && (
                                    <Box style={{ marginTop: 12 }}>
                                        <FormControl fullWidth variant="outlined" disabled={isView}>
                                            <ComboPadrao
                                                name="codcliente"
                                                label="Cliente"
                                                value={vendedor.codcliente}
                                                onChange={this.onChange}
                                                fieldId="codcliente"
                                                listItems={clientes}
                                                fieldDescription="fantasia"
                                                disabled={isView}
                                            />
                                        </FormControl>
                                    </Box>
                                )}

                            {vincvendexternoafornec &&
                                vendedor.vendedorexterno == ASIM && (
                                    <Box style={{ marginTop: 12 }}>
                                        <FormControl fullWidth variant="outlined" disabled={isView}>
                                            <ComboPadrao
                                                name="codfornecedor"
                                                label="Fornecedor"
                                                value={vendedor.codfornecedor}
                                                onChange={this.onChange}
                                                fieldId="codfornecedor"
                                                listItems={fornecedores}
                                                fieldDescription="fantasia"
                                                disabled={isView}
                                            />
                                        </FormControl>
                                    </Box>
                                )}

                            {vincvendexternoafornec &&
                                vendedor.vendedorexterno == ASIM && (
                                    <Box style={{ marginTop: 12 }}>
                                        <FormControl fullWidth variant="outlined" disabled={isView}>
                                            <ComboPadrao
                                                name="codusuario"
                                                label="Usuário"
                                                value={vendedor.codusuario}
                                                onChange={this.onChange}
                                                fieldId="codfuncionario"
                                                listItems={usuarios}
                                                fieldDescription="usuario"
                                                disabled={isView}
                                            />
                                        </FormControl>
                                    </Box>
                                )}
                        </TabContainer>
                    }

                    {/* Aba Empresas */}
                    {activetab === 1 && empresas.length > 1 && (
                        <TabContainer>
                            <Paper
                                variant="outlined"
                                style={{
                                    marginTop: 12,
                                    padding: 16
                                }}
                            >
                                <FormGroup>
                                    {this.state.empresas.map(empresa => (
                                        <FormControlLabel
                                            key={empresa.codigo}
                                            style={{
                                                borderBottom: '1px solid #eeeeee',
                                                marginLeft: 0,
                                                marginRight: 0,
                                                padding: '2px 8px'
                                            }}
                                            control={
                                                <Checkbox
                                                    checked={this.state.empresasSelecionadas.some(
                                                        codigo => Number(codigo) === Number(empresa.codigo)
                                                    )}
                                                    onChange={() => this.handleEmpresaChange(empresa.codigo)}
                                                    disabled={isView}
                                                    color="primary"
                                                />
                                            }
                                            label={empresa.fantasia}
                                        />
                                    ))}
                                </FormGroup>
                            </Paper>
                        </TabContainer>
                    )}

                    <br />
                    <br />

                    <FormActions
                        onSave={this.onClickSave}
                        onCancel={this.onClickCancel}
                        disableSave={isView}
                    />
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />

                {/* Comissão serviço */}
                <Dialog
                    open={openComissaoServico}
                    onClose={this.handleCloseComissaoServico}
                    maxWidth="bg"
                    fullWidth
                >
                    <DialogTitle className={classes.dialogTitle}>
                        Comissão por serviço
                    </DialogTitle>

                    <DialogContent className={classes.dialogContent}>
                        {openComissaoServico && (
                            <ComissaoVendedorServico
                                codVendedor={vendedor.codvendedor}
                                comissaoServicos={comissaoservicos}
                                onSave={(updateComissao) => {
                                    this.updateComissaoServicos(updateComissao);
                                    this.handleCloseComissaoServico();
                                }}
                                onClose={this.handleCloseComissaoServico}
                            />
                        )}
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

VendedorForm.propTypes =
{
    classes: PropTypes.object.isRequired
};

//export default VendedorForm;
export default withStyles(styles)(VendedorForm);